import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import axios from "axios";
import {
  getPreferredLanguage,
  persistPreferredLanguage,
} from "./utils/userPreferences";

i18n
  .use(Backend) // This loads translations from the server or public folder
  .use(LanguageDetector)
  .use(initReactI18next) // This is needed to use i18next with React
  .init({
    lng: getPreferredLanguage() || undefined,
    fallbackLng: "es", // Fallback language if translation is missing
    supportedLngs: ["es", "en"], // Supported languages
    detection: {
      // Language detection options
      order: ["querystring", "cookie", "localStorage", "navigator"],
      caches: ["localStorage", "cookie"],
      lookupQuerystring: "lang", // The query parameter to look for, e.g., ?lang=fr
      lookupLocalStorage: "wifiads-language",
    },

    interpolation: {
      escapeValue: false, // React already escapes values by default
    },
    react: { useSuspense: false },

    // Optionally, you can add translation files manually or use a backend
    backend: {
      loadPath: "/locales/{{lng}}/translation.json", // Path to your translation files
    },
  });

const updateDocumentLocale = (language) => {
  axios.defaults.headers.common["Accept-Language"] = language || "es";
  if (typeof document === "undefined") return;
  document.documentElement.lang = language || "es";
  document.documentElement.dir = i18n.dir(language);
};

i18n.on("languageChanged", updateDocumentLocale);
i18n.on("initialized", () => updateDocumentLocale(i18n.resolvedLanguage));

export async function setApplicationLanguage(language) {
  const normalizedLanguage = language === "en" ? "en" : "es";
  persistPreferredLanguage(normalizedLanguage);
  await i18n.changeLanguage(normalizedLanguage);
  return normalizedLanguage;
}

export default i18n;
